<template>
  <div>
    <div class="d-flex" v-if="!hideSearch">
      <div class="w-50 ms-auto">
        <v-text-field
            class="custom-search-field"
            @keydown.enter="onClickSearch"
            append-icon="mdi-magnify"
            @click:append="onClickSearch"
            v-model="search"
            :placeholder="actualPlaceholder"
            dense
            outlined/>
      </div>

      <slot name="filter"></slot>

      <v-btn
          v-if="add"
          elevation="0"
          class="no-uppercase btn-custom-primary ml-5"
          @click="add">
        <b-img
            class="mr-2"
            :src="require('@/assets/images/ic-plus.svg')"
            width="16"
            height="16"
        />
        {{ $t("base.create") }}
      </v-btn>
    </div>

    <v-data-table
        @click:row="itemClickHandle"
        :class="['home-data-table mt-10 text-body-1', { 'clickable-row': itemClick }]"
        :items-per-page="perPage"
        :page.sync="currentPage"
        :options.sync="options"
        :server-items-length="customTotalRows"
        hide-default-footer
        :loading="loading"
        :items="items"
        :headers="headers">

      <!-- Pass through custom slots -->
      <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>

      <template v-slot:item.name="{ item }">
        <div class="d-flex align-center">
          <div :style="itemClick ? { color: '#1890FF' } : {}">
            {{ shortenText(locale === 'en' && item.nameEng ? item.nameEng : item.name, 30) }}
          </div>
          <v-chip
            v-if="item.data && item.data.inCharge === 1"
            class="custom-chip-incharge">
            {{ $t(inChargeTranslationKey) }}
          </v-chip>
          <!-- Special tags for SOS cases -->
          <v-chip
            v-if="item.specialType === 2"
            small
            color="primary"
            text-color="white"
            class="ml-2">
            Code Blue
          </v-chip>
          <v-chip
            v-if="item.specialType === 3"
            small
            color="error"
            text-color="white"
            class="ml-2">
            Bạo hành
          </v-chip>
        </div>
      </template>
      <template v-slot:item.displayName="{ item }">
        <div class="d-flex align-center">
          <div v-if="itemClick" style="color: #1890FF;" @click="itemClickHandle(item)">
            {{ shortenText(item.displayName, 30) }}
          </div>
          <v-chip
            v-if="item.data && item.data.alertInterHospital === 1"
            class="custom-chip-inter-hospital">
            {{ $t('ui.interHospitalTag') }}
          </v-chip>
        </div>
      </template>
      <template v-if="!$scopedSlots['item.statusText']" v-slot:item.statusText="{ item }">
        <div>
          <v-chip
            v-if="item.active"
            class="custom-chip-active">
              {{ (locale === 'en' && item.active) ? 'Active' : 'Kích hoạt' }}
          </v-chip>
          <v-chip
            v-if="!item.active"
            class="custom-chip-inactive">
              {{ (locale === 'en' && !item.active) ? 'Inactive' : 'Bỏ kích hoạt' }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.message="{ item }">
        <div class="d-flex align-center">
          <div class="font-weight-bold" v-if="itemClick" style="color: #1890FF;" @click="itemClickHandle(item)">
            {{ shortenText(item.message, 30) }}
          </div>
        </div>
      </template>
      <template v-slot:item.address="{ item }">
        <div>
          <div>
            {{ shortenText(item.address, 30) }}
          </div>

        </div>
      </template>
      <template v-slot:item.description="{ item }">
        <div>
          <div class="description-cell">
            {{ item.description }}
          </div>
        </div>
      </template>

      <template v-if="!$scopedSlots['item.actions']" v-slot:item.actions="{ item }">
        <div class="text-right">
          <v-btn
              v-if="edit"
              small
              elevation="0"
              class="no-uppercase btn-custom-white mr-2 ms-auto"
              @click.stop="edit(item)"
          >
            <b-img
                class="mr-2"
                :src="require('@/assets/images/ic-edit-hospital.svg')"
                width="16"
                height="16"
            />
            {{ $t('ui.edit') }}
          </v-btn>

          <v-btn
              v-if="changePassword"
              small
              elevation="0"
              class="no-uppercase btn-custom-white mr-2 ms-auto"
              @click.stop="changePassword(item)"
          >
            <b-img
                class="mr-2"
                :src="require('@/assets/images/ic-lock.svg')"
                width="16"
                height="16"
            />
            {{ $t('user.changePassword') }}
          </v-btn>

          <v-btn
              v-if="onDelete"
              icon
              @click.stop="handleDelete(item)">
            <b-img
                :src="require('@/assets/images/ic-delete.svg')"
                width="22"
                height="22"
            />
          </v-btn>
        </div>
      </template>

      <template v-slot:item.targetsInfo="{ item }">
        <div class="py-2" style="max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          <span v-for="(value, index) in item.targetsInfo" :key="index">
            <span v-if="index > 0">, </span>{{ value.name }}<span v-if="checkOutOfHospital(item)"> - {{ value.confirmInfo && value.confirmInfo.confirmed === 1 ? $t("base.confirmed") : $t("base.unconfimred") }}</span>
          </span>
        </div>
      </template>

      <template v-if="!$scopedSlots['item.status']" v-slot:item.status="{ item }">
        <confirm-chip
            class="h-50"
            :is-confirm="item.status"
            :text-yes='$t(item.statusText)'
            :text-no='$t(item.statusText)'
        />
      </template>

      <template slot="no-data">
        <div class="w-100 align-content-center" style="min-height: 500px">
          <div class="w-100 d-flex">
            <img class="mx-auto" src="@/assets/images/ic-empty.svg" alt="empty"/>
          </div>
          <div class="text-center">{{ $t("base.noData") }}</div>
        </div>
      </template>

    </v-data-table>

    <div class="d-flex mt-6">
      <div class="ms-auto mt-3"> {{ paginationCurrentText }}</div>
      <b-pagination
          class="custom-pagination"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table">
      </b-pagination>
    </div>

  </div>

</template>

<script>
import {SOS_TYPE} from "../../config/constant";
import i18n from "../../lang/i18n";
import ConfirmChip from "../component/ConfirmChip.vue";
import {mapState} from "vuex";

export default {
  name: "d-table",
  components: {ConfirmChip},
  inheritAttrs: false,
  props: {
    fields: {
      type: [Array, Object],
      default: () => []
    },
    tableData: {
      type: [Array],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 10
    },
    edit: {
      type: Function,
    },
    onDelete: {
      type: Function,
    },
    onDeleteContent: {
      type: Function,
    },
    changePassword: {
      type: Function,
    },
    add: {
      type: Function,
    },
    itemClick: {
      type: Function,
    },
    rowClick: {
      type: Boolean,
      default: false,
    },
    getItems: {
      type: Function,
    },
    customTotalRows: {
      type: Number,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: ''
    },
    context: {
      type: String,
      default: 'general' // 'department', 'employee', or 'general'
    }
  },
  data() {
    return {
      options: {},
      search: "",
      currentPage: 1,
      dialog: false
    };
  },
  computed: {
    ...mapState(['locale']),
    inChargeTranslationKey() {
      switch (this.context) {
        case 'department':
          return 'department.inCharge'; // "Phụ trách liên viện"
        case 'employee':
          return 'employee.inCharge'; // "Phụ trách khoa"
        default:
          return 'department.inCharge'; // default fallback
      }
    },
    items() {
      return this.tableData
    },
    headers() {
      return this.fields.map(h => {
        if (!h.value) h.value = h.key
        if (!h.text) h.text = h.label
        h.class = 'text-body-1 font-weight-bold'
        h.width = h.width || ''; // Apply width or default to 'auto'
        return h
      })
    },
    totalRows() {
      return this.customTotalRows ? this.customTotalRows : this.tableData.length
    },
    serversideItemLength() {
      return this.customTotalRows ? this.customTotalRows : undefined
    },
    paginationCurrentText() {
      let last = this.currentPage * this.perPage
      let first = last - this.perPage + 1
      let total = this.totalRows
      last = last > total ? total : last
      return `${first} - ${last} / ${total}`
    },
    actualPlaceholder() {
      return this.placeholder || this.$t("base.placeholderSearch")
    }
  },
  watch: {
    options: {
      handler() {
        this.onClickSearch()
      },
      deep: true,
    },
  },
  methods: {
    checkOutOfHospital(data) {
      return !!(data &&
          data.data &&
          data.data.sosTypeInfo &&
          data.data.sosTypeInfo.sosTypeId === SOS_TYPE.OUT_THE_HOSPITAL);
    },
    onClickSearch() {
      if (this.getItems) {
        // console.log("this.options", this.options)
        let optionParams = {
          searchKey: this.search,
          sortBy: this.options.sortBy[0],
          orderBy: this.options.sortDesc[0] ? "DESC" : "ASC",
          page: this.currentPage,
          itemsPerPage: this.options.itemsPerPage,
        }
        // console.log("optionParams", optionParams)
        this.getItems(optionParams)
      }
    },
    itemClickHandle(item) {
            if (this.itemClick) this.itemClick(item)
    },
    handleDelete(item) {
      let contents
      contents = this.onDeleteContent ? this.onDeleteContent(item) : []
      if (typeof contents === 'string') contents = [contents]
      if (contents.length === 0) {
        contents = [
          i18n.t('ui.confirmDataDelContent'),
          `\b ${item.name}?`, '\n',
          i18n.t('ui.confirmDataDelContent2'),
        ]
      } else if (contents.length === 1) {
        contents.push(
            `\b ${item.name}?`, '\n',
            i18n.t('ui.confirmDataDelContent2'),
        )
      }
      this.$root.$emit('confirmDialog', {
        title: i18n.t('ui.confirmDataDeletion'),
        contents: contents,
        variant: "delete",
        data: item,
        onConfirm: this.onDelete,
        textConfirm: i18n.t('ui.delete'),
      })
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
  },

};
</script>

<style scoped>

.custom-pagination >>> .page-item {
  margin: 5px;
}

.custom-pagination >>> .page-item .page-link {
  color: #000000;
}

.custom-pagination >>> .active > .page-link {
  background: unset;
  color: #1890FF;
  border: 1px solid #1890FF;
}

.custom-pagination >>> .disabled > .page-link {
  color: #D9D9D9;
}

.custom-chip-inter-hospital {
  color: #52C41A;
  border: 1px solid #B7EB8F !important;
  border-radius: 2px;
  background-color: #F6FFED !important;
}

.custom-chip-incharge {
  color: #FAAD14;
  border: 1px solid #FFE58F !important;
  border-radius: 2px;
  background-color: #FFFBE6 !important;
}

.custom-chip-active {
  color: #52C41A;
  border: 1px solid #B7EB8F !important;
  border-radius: 2px;
  background-color: #F6FFED !important;
}

.custom-chip-inactive {
  color: #262626;
  border: 1px solid #D9D9D9 !important;
  border-radius: 2px;
  background-color: #FAFAFA !important;
}

.custom-search-field >>> .v-input__append-inner {
  border-left: 1px solid #9E9E9E; /* Adjust color and thickness as needed */
  padding-left: 12px;
  padding-block: 8px;
  margin-top: 0px !important;
}

.custom-search-field >>> .v-input__append-inner:hover {
  border-left: 1px solid #000000; /* Adjust color and thickness as needed */
  padding-left: 12px;
  padding-block: 8px;
  margin-top: 0px !important;
}

/* Description cell styling - exactly 3 lines with ellipsis */
.description-cell {
  /* Multi-line clamp */
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  line-height: 1.4 !important;
  max-height: calc(1.4em * 3) !important;
  /* Prevent horizontal scroll or table expansion by long words/URLs */
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
  white-space: normal !important;
  /* Constrain within the table cell width */
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

</style>


.clickable-row {
  cursor: pointer;
}
